import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { LeadsDetailsTableHeader } from './utils/leadsDetailPageHelper';
import { useDispatch, useSelector } from 'react-redux';
import { getLeadDeatils } from '../../../../redux/features/dashboardSlice';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { Stack } from '@mui/material';

export default function LeadsDetails() {
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const queryFromDate = searchParams.get('fromDate');
  const queryToDate = searchParams.get('toDate');

  const [filters, setFilters] = useState({
    fromDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    toDate: dayjs().endOf('month').format('YYYY-MM-DD'),
  });

  const leadsDetailsLoading = useSelector((state) => state.dashboard.leadDetails.loading);
  const leadsDetailsData = useSelector((state) => state.dashboard.leadDetails.data);
  const leadsDetailsMeta = useSelector((state) => state.dashboard.leadDetails.meta);

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });
  const filterHelper = (value, key) => {
    if (!value || !key) return;
    setFilters((prev) => ({ ...prev, [key]: value }));
  };
  useEffect(() => {
    const params = {
      search: tableState?.search,
      page: tableState?.page,
      limit: tableState?.pageSize,
      sortBy: tableState.sort.field,
      sortDirection: tableState.sort.direction,
      startDate: filters.fromDate,
      endDate: filters.toDate,
    };
    dispatch(getLeadDeatils(params));
  }, [filters, tableState.search, tableState.page, tableState.pageSize, dispatch, tableState.sort]);
  useEffect(() => {
    filterHelper(dayjs(queryFromDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), 'fromDate');
    filterHelper(dayjs(queryToDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), 'toDate');
  }, [queryFromDate, queryToDate]);

  return (
    <GlobalWrapper title={'Leads Details'}>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} mb={1}>
        <FromAndToDatePicker
          fromDate={filters.fromDate}
          toDate={filters.toDate}
          setFromDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'fromDate')}
          setToDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'toDate')}
          fullWidth
        />
      </Stack>
      <GlobalTable
        rowUniqueId="leadId"
        headers={LeadsDetailsTableHeader}
        rows={leadsDetailsData}
        loading={leadsDetailsLoading}
        tableState={tableState}
        setTableState={setTableState}
        meta={leadsDetailsMeta}
      />
    </GlobalWrapper>
  );
}
